import { Nillable } from '@web/utils';
import { Role } from '@web/shared/module/auth';
import { FormControl, FormGroup } from '@angular/forms';

export type UserControls = {
  firstName: FormControl<Nillable<string>>;
  lastName: FormControl<Nillable<string>>;
  displayName: FormControl<Nillable<string>>;
  email: FormControl<string>;
  username: FormControl<string>;
  roles: FormControl<Role[]>;
  password: FormControl<Nillable<string>>;
  newsletter: FormControl<boolean>;
};

export class UserFormData {
  public constructor(
    private readonly data: {
      email: string;
      firstName?: Nillable<string>;
      lastName?: Nillable<string>;
      displayName?: Nillable<string>;
      newsletter: boolean;
      password?: Nillable<string>;
      roles: Role[];
      username: string;
    },
  ) {}

  public get firstName(): Nillable<string> {
    return this.data.firstName;
  }

  public get lastName(): Nillable<string> {
    return this.data.lastName;
  }

  public get displayName(): Nillable<string> {
    return this.data.displayName;
  }

  public get newsletter(): boolean {
    return this.data.newsletter;
  }

  public get username(): string {
    return this.data.username;
  }

  public get email(): string {
    return this.data.email;
  }

  public get roles(): Role[] {
    return this.data.roles;
  }

  public get password(): Nillable<string> {
    return this.data.password;
  }
}

/* prettier-ignore */
export type UserFormGroup = FormGroup<UserControls>;
